import React from 'react';
export const formatErrorMessages = (messages: string[]): JSX.Element =>
  messages.length > 1 ? (
    <ul className={'no-b-m'}>
      {messages.map((m, index) => (
        <li key={index}>{m}</li>
      ))}
    </ul>
  ) : (
    <>{messages.join('/n')}</>
  );
